import { Slide } from '@/components/core/Slide';
import audioFile from './33-installation.mp3';

const autoNextDuration = 47000;
const transcript = `
  Tot slot kijken we naar installatiebedrijven.

  Slimme offertes en werkbonnen kunnen automatisch worden opgesteld door AI op basis van klantwensen 
  en projectdata, wat veel administratief werk bespaart.

  Met AI-ondersteunde storingdiagnose kunnen monteurs sneller storingen oplossen, bijvoorbeeld door 
  foto's van installaties te analyseren.

  Generatieve AI kan worden ingezet voor handleidingen en support, waarbij onderhoudsinstructies 
  gepersonaliseerd en in begrijpelijke taal worden gegenereerd.

  En route-optimalisatie voor monteurs zorgt ervoor dat AI slimme planningen kan maken voor installateurs 
  om reistijd te minimaliseren.

  De impact hiervan is direct merkbaar: efficiëntere monteurs, lagere kosten, en snellere service.
`;

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1 className="text-4xl font-bold mb-8">Installatiebedrijven 🔧</h1>

        <ul className="space-y-4 list-disc">
          <li>Slimme offertes en werkbonnen: Automatisch opstellen op basis van klantwensen</li>
          <li>AI-ondersteunde storingdiagnose: Sneller storingen oplossen met foto-analyse</li>
          <li>Generatieve AI voor handleidingen: Gepersonaliseerde onderhoudsinstructies</li>
          <li>Route-optimalisatie voor monteurs: Slimme planningen om reistijd te minimaliseren</li>
        </ul>
      </div>
    </Slide>
  );
};
